import React, { useState } from "react";

//input files --->
import CareersRegisterInputEmail from "./CareersRegisterInputEmail";
import CareersRegisterInputMobile from "./CareersRegisterInputMobile";
import CareersRegisterInputName from "./CareersRegisterInputName";

//Select files-->
import CareersRegisterSelectPassingYear from "./CareersRegisterSelectPassingYear";
import CareersRegisterSelectAreaInterest from "./CareersRegisterSelectAreaInterest";
import CareersRegisterSelectStudying from "./CareersRegisterSelectStudying";

//checkbox and radio
import CareersRegisterAskPassport from "../registration/CareersRegisterAskPassport";
import CareersRegisterInterestedIn from "../registration/CareersRegisterInterestedIn";
import Cookies from "universal-cookie";
import CareersRegisterInputLocation from "./CareersRegisterLocation";

const CareersRegisterControl = (props) => {
  const [isMobileFocused, setIsMobileFocused] = useState(false);
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [selectedAreaOfInterestValues, setSelectedAreaOfInterestValues] = useState([]);

  const cookies = new Cookies();

  const {
    control,
    name,
    values,
    setFieldValue,
    errors,
    touched,
    fieldSelectType,
    placeholder,
    maxLimit,
    handleBlur,
    dropdownData,
    domain,
    searchBar,
    updateTouchedFields,
    setTouched
  } = props;
  switch (control) {
    case "text":
      if (name == "email") {
        return (
          <CareersRegisterInputEmail
            setFieldValue={setFieldValue}
            values={values}
            name={name}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            setIsEmailFocused={setIsEmailFocused}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
          />
        );
      } else if (name == "mobile") {
        return (
          <CareersRegisterInputMobile
            setFieldValue={setFieldValue}
            name={name}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            selectedCountry={props.selectedCountry}
            setSelectedCountry={props.setSelectedCountry}
            geolocationData={props.geolocationData}
            setIsMobileFocused={setIsMobileFocused}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
          />
        );
      } else if (name == "studentname" || name == "name") {
        return (
          <CareersRegisterInputName
            setFieldValue={setFieldValue}
            name={name}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
          />
        );
      } else if (name == "location") {
        return (
          <CareersRegisterInputLocation
            setFieldValue={setFieldValue}
            values={values}
            errors={errors}
            touched={touched}
            placeholder={placeholder}
            handleBlur={handleBlur}
            domain={domain}
            name={name}
            updateTouchedFields={updateTouchedFields}
            setSyncSignupValues={props.setSyncSignupValues}
          />
        );
      }
    case "dropdown-singleSelect-radio":
      return (
        <CareersRegisterSelectStudying
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          dropdownData={dropdownData}
          domain={domain}
          handleOnFocus={(event, name, item) => props.handleOnFocus(event, name, item)}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          setTouched={props.setTouched}
          isUpdateProfile={props.isUpdateProfile}
          setFormikValues={props.setFormikValues}
          setReinitialize={props.setReinitialize}
          setSelectedAreaOfInterestValues={setSelectedAreaOfInterestValues}
          postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => props.postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
          areaOfInterestApiCall ={(level, interest, eduInterest, cerInterest) => props.areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
          apiCallBasedOnStudyingIn={(name, option) => props.apiCallBasedOnStudyingIn(name, option)}
        />
      );
    case !!name && "dropdown-singleSelect":
      return (
        <CareersRegisterSelectPassingYear
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          dropdownData={dropdownData}
          handleOnFocus={(event, name, item) => props.handleOnFocus(event, name, item)}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          isUpdateProfile={props.isUpdateProfile}
          domain={props.domain}
          setTouched={props.setTouched}
          setFormikValues={props.setFormikValues}
          postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => props.postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
          areaOfInterestApiCall ={(level, interest, eduInterest, cerInterest) => props.areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
        />
      );

    case "dropdown-multiSelect-checkbox":
      return (
        <CareersRegisterSelectAreaInterest
          name={name}
          label={props.label}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          setTouched={setTouched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          dropdownData={dropdownData}
          handleOnFocus={(event, name, item) => props.handleOnFocus(event, name, item)}
          maxLimit={maxLimit}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          setFormikValues={props.setFormikValues}
          setReinitialize={props.setReinitialize}
          selectedAreaOfInterestValues={selectedAreaOfInterestValues}
          setSelectedAreaOfInterestValues={setSelectedAreaOfInterestValues}
        />
      );

    case "checkbox":
      return (
        <CareersRegisterInterestedIn
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          fieldErrors={props.fieldErrors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          interestedInCheckbox={props.interestedInCheckbox}
          handleInterestedCheckbox={(item, id) =>
            props.handleInterestedCheckbox(item, id)
          }
          item={props.item}
          dropdownData={dropdownData}
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
          setTouched={props.setTouched}
          domain={props.domain}
          postUpdateProfileOnChange={(option, val, interest, certificateId, isLevel) => props.postUpdateProfileOnChange(option, val, interest, certificateId, isLevel)}
          setFormikValues={props.setFormikValues}
          selectedAreaOfInterestValues={selectedAreaOfInterestValues}
          setSelectedAreaOfInterestValues={setSelectedAreaOfInterestValues}
          areaOfInterestApiCall ={(level, interest, eduInterest, cerInterest) => props.areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
        />

      );

    case "radio":
      return (
        <CareersRegisterAskPassport
          name={name}
          setFieldValue={setFieldValue}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
          constants={props.constants}
          placeholder={placeholder}
          radioBtn={props.radioBtn}
          dropdownData={dropdownData}
          handleRadioChange={(item, id) =>
            props.handleRadioChange(item, id)
          }
          searchBar={searchBar}
          updateTouchedFields={updateTouchedFields}
        />
      );

    default:
      return null;
  }

};

export default CareersRegisterControl;
